/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Link from "next/link";
import router from "next/router";
import styled from "styled-components";

import { AuthBody, AuthHeader, AuthWrapper, EndOfFormText, StyledText } from "src/components/Login/Styles";
import { EmailIcon, UrbitIcon } from "src/components/Signup/Icons";
import { SignupMethodButton, IconWrapper, OrDivider } from "src/components/Signup/SignupMethodButton";
import { RedLink } from "src/components/Splash/EnterToken";
import { StyledLink } from "src/components/UI/Links";
import { AppRoutes } from "src/lib/constants";

export default function Login() {
  return (
    <AuthWrapper>
      <AuthBody>
        <AuthHeader>
          <StyledText>
            <Link href="/" passHref>
              <StyledLink style={{ color: "#cccccc" }}>VIENNA HYPERTEXT</StyledLink>
            </Link>
            <span style={{ color: "#cccccc" }}> / </span> Sign In
          </StyledText>
        </AuthHeader>
        <Wrapper>
          <FlexCenter>
            <SignupMethodButton onClick={() => router.push(AppRoutes.SigninEmail)}>
              <IconWrapper>
                <EmailIcon />
              </IconWrapper>
              Sign in with Email
            </SignupMethodButton>
            <OrDivider style={{ marginTop: "0px", marginBottom: "5px" }} />
            <SignupMethodButton style={{ marginTop: "10px" }} onClick={() => router.push(AppRoutes.SigninUrbit)}>
              <IconWrapper>
                <UrbitIcon />
              </IconWrapper>
              Sign in with Urbit
            </SignupMethodButton>
            <EndOfFormText>
              Don&apos;t have an account? {/*  */}
              <Link href={AppRoutes.Waitlist} passHref>
                <RedLink>Join waitlist</RedLink>
              </Link>{" "}
              or{" "}
              <Link href={AppRoutes.Register} passHref>
                <RedLink>sign up</RedLink>
              </Link>
            </EndOfFormText>
          </FlexCenter>
        </Wrapper>
      </AuthBody>
    </AuthWrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  width: 100%;
`;

const FlexCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
